export default __webpack_public_path__ + "static/media/Didot_Regular.89b353f0.ttf";